import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../constants/constants';

export const componentKey = "PAYER/PAYER_LIST"

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload
        },
        setPayersReportHeaderLoadingState: (state, action) => {
            state.payersReportHeaderLoadingState = action.payload
        },

        setPayersList: (state, action) => {
            state.payersList = action.payload
        },

        setHighlightedPayer: (state, action) => {
            state.highlightedPayer = action.payload
        },

        setSelectedPayers: (state, action) => {
            state.selectedPayers = action.payload
        },

        toggleSelectedPayer: (state, action) => {
            const { payer, selectedPayers, isChecked } = action.payload;

            if (!isChecked) {
                state.selectedPayers = selectedPayers.filter(selectedRow => selectedRow.PayerDetailId !== payer?.PayerDetailId)
            } else {
                state.selectedPayers = [...selectedPayers, payer];
            }
        },

        setFormsStatus: (state, action) => {
            state.formsStatus = action.payload
        },

        setRecipientsStatus: (state, action) => {
            state.recipientsStatus = action.payload
        },

        setDeActivateConfirmationModalOpen: (state, action) => {
            state.deActivateConfirmationModalOpen = action.payload
        },

        setDeleteConfirmationModalOpen: (state, action) => {
            state.deleteConfirmationModalOpen = action.payload
        },

        setPieChartLoader: (state, action) => {
            state.pieChartLoader = action.payload
        },

        setGenerateReportDrawer: (state, action) => {
            state.showGenerateReportDrawer = action.payload
        },

        setSelectedReportsHeader: (state, action) => {
            const { index, isChecked } = action.payload
            state.reportsHeaders[index].checked = isChecked
        },

        toggleReportsHeader: (state, action) => {
            const { isChecked, reportsHeaders } = action.payload
            state.reportsHeaders = reportsHeaders.map(item => { return { ...item, checked: isChecked } })
        },

        setShowAssignToUserTable: (state, action) => {
            state.showAssginToUserTable = action.payload;
        },

        setUsersList: (state, action) => {
            state.usersList = action.payload;
        },

        setSelectedUsers: (state, action) => {
            state.selectedUsers = action.payload;
        },

        setAssignToUserTableLoader: (state, action) => {
            state.assignToUserTableLoader = action.payload
        },

        setTotalUsers: (state, action) => {
            state.totalUsers = action.payload;
        },

        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },

        setReportHeaders: (state, action) => {
            state.reportsHeaders = action.payload
        },

        setGenerateReportStates: (state, action) => {
            state.generateReportStates = { ...state.generateReportStates, ...action.payload }
        },

        setSearchOption: (state, action) => {
            state.searchOption = action.payload;
        },

        setAssignPayerPaginationState: (state, action) => {
            state.assignPayerPaginationState = { ...state.assignPayerPaginationState, ...action.payload }
        },

        setActivateConfirmationModalOpen: (state, action) => {
            state.activateConfirmationModalOpen = action.payload
        },
        setShouldLoadPaginatedPayersList: (state, action) => {
            state.shouldLoadPaginatedPayersList = action.payload
        }

    },
    initialReducerState: {
        payersList: [],
        highlightedPayer: {},
        selectedPayers: [],
        loadingState: { state: PAGE_STATE.LOADING, message: "" },
        payersReportHeaderLoadingState: { state: PAGE_STATE.LOADING, message: "" },
        formsStatus: {},
        recipientsStatus: {},
        deActivateConfirmationModalOpen: false,
        activateConfirmationModalOpen: false,
        deleteConfirmationModalOpen: false,
        pieChartLoader: false,
        // Assign To Users Table
        showAssginToUserTable: false,
        assignToUserTableLoader: false,
        usersList: [],
        selectedUsers: [],
        totalUsers: 0,

        paginationState: {
            PageNumber: 1,
            PageSize: 10,
            FilterText: "",
            IsDesc: true,
            IdNumber: "",
            Skip: 0,
            totalPayers: 10,
        },

        assignPayerPaginationState: {
            PageNumber: 1,
            PageSize: 10,
            FilterText: "",
            IsDesc: true,
            Skip: 0,
            totalPayers: 10,
        },

        // Generate Report
        showGenerateReportDrawer: false,
        reportsHeaders: [],
        generateReportStates: { fromDate: "", toDate: "", extension: "XLSX" },

        searchOption: { label: "Search by Name", value: "NAME" },
        shouldLoadPaginatedPayersList: false,
    }
});

export const { setLoadingState, setPayersReportHeaderLoadingState, setPayersList, setHighlightedPayer,
    setSelectedPayers, toggleSelectedPayer, setFormsStatus, setRecipientsStatus, setDeActivateConfirmationModalOpen,
    setDeleteConfirmationModalOpen, setPieChartLoader, setGenerateReportDrawer, setSelectedReportsHeader, toggleReportsHeader, setShowAssignToUserTable, setUsersList, setSelectedUsers,
    setAssignToUserTableLoader, setTotalUsers, setPaginationState, setReportHeaders, setGenerateReportStates, setSearchOption, setAssignPayerPaginationState, setActivateConfirmationModalOpen, setShouldLoadPaginatedPayersList } = actions;

